var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7385 5.46883L10.0304 8.36197H12.0613C12.096 9.47551 11.6881 10.5574 10.9268 11.3708C10.1655 12.1843 9.11298 12.6629 7.99959 12.702C7.33418 12.7034 6.68025 12.5287 6.10416 12.1957L5.11559 13.2517C5.96487 13.8339 6.96993 14.1465 7.99959 14.1488C10.9916 14.1488 13.4156 11.5591 13.4156 8.36197H15.4464L12.7385 5.46883ZM3.93845 8.36197C3.90375 7.24843 4.31169 6.16651 5.07295 5.35309C5.83422 4.53967 6.88677 4.06103 8.00016 4.02197C8.66557 4.02057 9.31951 4.19524 9.89559 4.52825L10.8842 3.47225C10.0347 2.89017 9.02939 2.57772 7.99959 2.57568C5.00988 2.57568 2.58359 5.1654 2.58359 8.36254H0.552734L3.26073 11.2557L5.96873 8.36254L3.93845 8.36197Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.362793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.6b0c328f68fe1814e58f2298dcc250cf.svg";
export { ForwardRef as ReactComponent };